import { useState } from 'react'

export default function Monogram({ team, size = 24 }) {
  const [failed, setFailed] = useState(false)
  const s = `${size}px`
  const radius = `${Math.round(size / 4)}px`

  if (team.slug && !failed) {
    return (
      <img
        className="mono"
        src={`/clubs/${team.slug}.png`}
        alt={team.name}
        loading="lazy"
        decoding="async"
        width={size}
        height={size}
        onError={() => setFailed(true)}
        style={{ width: s, height: s, objectFit: 'contain', borderRadius: radius }}
      />
    )
  }

  return (
    <span
      className="mono"
      style={{
        width: s,
        height: s,
        background: team.color,
        fontSize: `${Math.round(size * 0.42)}px`,
        borderRadius: radius,
      }}
    >
      {team.monogram}
    </span>
  )
}
